import * as config from "../app.config";
import { USER_MESSAGE, setHeaders } from "./User";
import axios from "axios";
import moment from "moment";
export const FETCH_TAGS = "FETCH_TAGS";
export const ADD_TAG = "ADD_TAG";
export const UPDATE_TAG = "UPDATE_TAG";
export const DELETE_TAG = "DELETE_TAG";

function _handleErrors(err) {
  return dispatch => {
    const status = (err && err.response && err.response.status) || 401;
    switch (status) {
      case 401:
        dispatch({
          type: USER_MESSAGE,
          msgType: "error",
          text: "Invalid or expired session, please login again",
          key: moment().unix()
        });
        //dispatch(handleLogout());
        break;
      case 409:
        dispatch({
          type: USER_MESSAGE,
          msgType: "error",
          text: "Item already exists",
          key: moment().unix()
        });
        break;
      case 403:
        //dispatch(handleLogout());
        break;
      default:
    }
  };
}

export function addTag(tagName) {
  return (dispatch, getState) => {
    const postData = {
      name: tagName
    };

    axios
      .post(`${config.ENDPOINTS["main"]}/tag`, postData, {
        headers: setHeaders()
      })
      .then(resp => {
        dispatch(fetchTags());
        dispatch({
          type: USER_MESSAGE,
          msgType: "success",
          text: "Added successfully",
          key: moment().unix()
        });
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function updateTag(values) {
  return (dispatch, getState) => {
    const postData = {
      id: values.tagId,
      name: values.tagName
    };

    axios
      .put(`${config.ENDPOINTS["main"]}/tag`, postData, {
        headers: setHeaders()
      })
      .then(resp => {
        dispatch(fetchTags());
        dispatch({
          type: USER_MESSAGE,
          msgType: "success",
          text: "Update successfully",
          key: moment().unix()
        });
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function deleteTag(values) {
  return (dispatch, getState) => {
    axios
      .delete(`${config.ENDPOINTS["main"]}/tag/${values.id}`, {
        headers: setHeaders()
      })
      .then(resp => {
        dispatch(fetchTags());
        dispatch({
          type: USER_MESSAGE,
          msgType: "success",
          text: "Deleted tag successfully",
          key: moment().unix()
        });
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}

export function fetchTags() {
  return (dispatch, getState) => {
    axios
      .get(`${config.ENDPOINTS["main"]}/tag/list`, {
        headers: setHeaders()
      })
      .then(resp => {
        dispatch({ type: FETCH_TAGS, payload: resp.data });
      })
      .catch(err => {
        dispatch(_handleErrors(err));
      });
  };
}
